import React, { useState } from "react";
import { FormGroup, FormGroupLabel, TextInput, Select } from "gumdrops";

export default function CreateAdForm() {
  const [campaigns, setCampaigns] = useState({ fruit: 1 });

  const _handleSelectChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setCampaigns({ [name]: value });
  };

  const [jiraName, setJiraName] = useState("");

  const _handleJiraChange = ({ target }) => setJiraName(target.value);
  return (
    <div>
      <FormGroup>
        <FormGroupLabel text="Folder*" />
        <Select
          options={myOptions}
          name="fruit"
          value={campaigns}
          onChange={_handleSelectChange}
          size="sm"
        />
        <FormGroupLabel text="Jira Url (optional)" />
        <TextInput
          name="jira"
          onChange={_handleJiraChange}
          value={jiraName}
          placeholder="https://gumgum.jira.com/browse/DTR-5947"
          size="sm"
          type="url"
        />
      </FormGroup>
    </div>
  );
}

const myOptions = [
  { name: "Dev: Make this a Search Select UI element", value: 1 },
  { name: "apples", value: 2 },
];
